import { render, staticRenderFns } from "./UK.vue?vue&type=template&id=9cb0f26c&"
import script from "./UK.vue?vue&type=script&lang=js&"
export * from "./UK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports